import React from 'react';
import { signOut } from '../redux/userSlice';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

function Account() {
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const account = useSelector(state => state.user.user);

	const handleSignOut = () => {
		dispatch(signOut());
		navigate("/login");
	}

	return(
		<div className="content mx-2 sm:mx-auto">
			<h1>Account</h1>

			<div className="journal rounded sm:w-6/12 grid gric-cols-1 m-auto p-6">
				<div className="my-2">
					<p className='font-bold'>Name</p>
					<p>{account.name}</p>
				</div>

				<div className="my-2">
					<p className='font-bold'>Username</p>
					<p>{account.username}</p>
				</div>

				<div className="my-2">
					<p className='font-bold'>Email</p>
					<p>{account.email}</p>
				</div>

				<Link to={'/reset'}><p className='link-embedded'>Reset password</p></Link>
			</div>
			<button onClick={() => handleSignOut()} className='btn-primary m-4'>Sign Out</button>
		</div>
	)
}

export default Account;